export default __webpack_public_path__ + "static/media/userProfile.2a0ff6d3.png";